import { render } from "./CreateRamification.vue?vue&type=template&id=6a527070"
import script from "./CreateRamification.vue?vue&type=script&lang=js"
export * from "./CreateRamification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__